import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ReferralForm } from "@/components/ReferralForm";
import { ReferralList } from "@/components/ReferralList";

export default function Dashboard() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get("/referrals/mine").then((r) => setItems(r.data)).catch(() => {}), []);
  useEffect(() => {
    load();
  }, [load]);

  return (
    <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:py-12" data-testid="dashboard-page">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#0F2D5E]">Ciao {user?.name?.split(" ")[0]}</p>
      <h1 className="mt-2 text-4xl font-extrabold tracking-tight sm:text-5xl">Le tue segnalazioni</h1>
      <div className="mt-8 grid gap-8 lg:grid-cols-12">
        <section className="rise rounded-3xl border border-[#E2E5DC] bg-white p-5 sm:p-7 lg:col-span-5" data-testid="new-referral-section">
          <h2 className="mb-5 text-xl font-bold">Nuova segnalazione</h2>
          <ReferralForm onCreated={load} />
        </section>
        <section className="rise d1 lg:col-span-7" data-testid="my-referrals-section">
          <div className="mb-4 flex items-baseline justify-between">
            <h2 className="text-xl font-bold">Inviate</h2>
            <span className="font-mono text-sm text-[#75867E]" data-testid="my-referrals-count">{items.length}</span>
          </div>
          <ReferralList items={items} />
        </section>
      </div>
    </main>
  );
}
